import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { reFormatDate } from "../../../../utils/utils";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";


export function TotalsVatR({ infoData }) {
  const styf = { fontWeight: "1200" };
  const cls = useRptAF();
  const totals = infoData.tot;

  const styleE={
      border: "solid 1px ",
      borderColor: "black",
      textAlign: "center",
      padding: 1,
      fontSize: "0.8rem",
      fontWeight: "bold",
  };
  const styleTo={
      border: "solid 1px ",
      borderColor: "black",
      textAlign: "center",
      fontSize: "0.9rem",
      fontWeight: "bold",
  };
  return (
      <Grid item container className={cls.rootBdy}>
    <Grid item container className={cls.rootBdyup}>
      <Grid container lg={12} md={12} className={cls.rootBdydown}>
      <Grid container xs={12} /*className={cls.rootchip}*/>
        <Grid item xs={3} style={styleE}>
          {"إجمالي عدد السجلات"}
        </Grid>
        <Grid item xs={3} style={styleE}>
          {infoData.tot1}
        </Grid>
        <Grid item xs={3} style={styleE}>
          {infoData.tot2}
        </Grid>
        <Grid item xs={3} style={styleE}>
          {infoData.tot3}
        </Grid>       
      </Grid>
      <Grid container xs={12} /*className={cls.rootchip}*/>
        <Grid item xs={3} style={styleTo}>
          {totals?.rowsCount}
        </Grid>
        <Grid item xs={3}  style={styleTo}>
          {parseFloat(totals?.TotalBeforVat).toFixed(2)}
        </Grid>
        <Grid item xs={3}  style={styleTo}>
          {parseFloat(totals?.TotalVat).toFixed(2)}
        </Grid>
        <Grid item xs={3}  style={styleTo}>
          {parseFloat(totals?.TotalAfterVat).toFixed(2)}
        </Grid>
       
      </Grid>
    </Grid>
    </Grid>
    </Grid>
  );
}


function BodyVat({ data, infoData, isLast }) {
    const { t } = useTranslation(["forms", "translation"]);
    const cls = useRptAF();
  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.55rem",
    width: "150px",
    fontFamily: "Amiri-Regular",
    fontWeight:"bold",
  };
  const cellSDel = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    maxWidth: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    // { title: "", field: "no" },
    { title: "تاريخ القيد", field: "Date" ,
        render: (expense) => reFormatDate(expense.Date)
    },
    // { title: "القيد", field: "proc_id" },
    // { title: "البيان/الشرح", field: "notes", cellStyle: cellSDel },
    { title: "رقم الفاتورة", field: "bill_no" },
    {
      title: "العميل",
      field: "customer_name",
      cellStyle:cellS,
    },
    { title: "الملف الضريبي", field: "taxno"},
    { title: "المبلغ قبل الضريبة", field: "TotalBeforVat" },
    { title: "الضريبة", field: "TotalVat" },
    { title: "المبلغ بعد الضريبة", field: "TotalAfterVat" },
  ];

  const newData = data.map((row, i) => {
    return {
      ...row,
      no:i+1,
      TotalBeforVat: parseFloat(row.TotalBeforVat).toFixed(2),
      TotalVat: parseFloat(row.TotalVat).toFixed(2),
      TotalAfterVat: parseFloat( row.TotalAfterVat).toFixed(2),
    };
  });
  return (
    <Grid item container style={{fontFamily: "Amiri-Regular"}}>
      <Grid item container style={{ direction: "rtl",paddingTop:"0.7rem"}}>
        <Grid
          item
          xs={12}
         
        >
          <MaterialTable
            style={{ boxShadow: "none",width:"100%" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",   
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={newData}
          />
          {isLast && <TotalsVatR infoData={infoData ?? []} />}
        </Grid>
      </Grid>    
    </Grid>
  );
}

export default BodyVat;
